import { render, staticRenderFns } from "./SecretariaView.vue?vue&type=template&id=ec702508&scoped=true&"
import script from "./SecretariaView.vue?vue&type=script&lang=js&"
export * from "./SecretariaView.vue?vue&type=script&lang=js&"
import style0 from "./SecretariaView.vue?vue&type=style&index=0&id=ec702508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec702508",
  null
  
)

export default component.exports